import React from "react";

const Home = props => (
  <svg viewBox="0 0 20 19" fill="none" {...props}>
    <path
      d="M19.883 8.484L17.5 6.531V3.484a.252.252 0 00-.234-.234h-.782c-.156 0-.234.117-.234.234v2.032l-5.469-4.454A1.194 1.194 0 0010 .79c-.313 0-.586.078-.82.273L.117 8.485C.04 8.524 0 8.602 0 8.72c0 .078 0 .156.04.195l.39.469a.355.355 0 00.273.117c.078 0 .117 0 .195-.078L2.5 8.132v9.493c0 .352.273.625.625.625h5a.642.642 0 00.625-.625v-5h2.5v5c0 .352.273.625.625.625h5a.642.642 0 00.625-.625V8.133l1.563 1.289c.078.078.117.078.195.078.117 0 .195-.04.273-.117l.39-.469c.04-.039.04-.117.04-.195 0-.117-.04-.196-.078-.235zM16.21 17l-3.75.04V12c0-.313-.274-.625-.586-.625h-3.79a.642.642 0 00-.624.625v5H3.75V7.117L10 2l6.25 5.117L16.21 17z"
      fill="#B3B3B3"
    />
  </svg>
);

export default Home;
